import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import { type NotificationRouteResource } from "@exonn/js-sdk";

export const module: ModuleOptions<NotificationRouteResource> = {
  resource: ResourceEnum.NotificationRoute,
  bigIcon: <span className={"icon-20-send_chnl"} />,
  smallIcon: <span className={"icon-15-send_chnl"} />,
};
